var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('payments-filter-component',{attrs:{"ui":_vm.ui,"routeDetails":_vm.routeDetails,"routePayments":_vm.routePayments}})}
var staticRenderFns = []

export { render, staticRenderFns }